// extracted by mini-css-extract-plugin
export default {"message":"ChatMessage_message__xLstW","fileMessage":"ChatMessage_fileMessage__f0jXv","fileIcon":"ChatMessage_fileIcon__L950p","messageMy":"ChatMessage_messageMy__QBJI-"};